
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dSB3l", function(module, exports) {

var $gRzR4 = parcelRequire("gRzR4");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $eEA8O = parcelRequire("eEA8O");


var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $6f0Oj = parcelRequire("6f0Oj");

var $cwkWT = parcelRequire("cwkWT");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $fHyH9 = parcelRequire("fHyH9");

var $5z48q = parcelRequire("5z48q");


var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $ibDKJ = parcelRequire("ibDKJ");


var $bQm3c = parcelRequire("bQm3c");


var $7aRa9 = parcelRequire("7aRa9");


var $luv00 = parcelRequire("luv00");


var $ep3mz = parcelRequire("ep3mz");


var $i4dNk = parcelRequire("i4dNk");


var $aSsfA = parcelRequire("aSsfA");


var $9wGTI = parcelRequire("9wGTI");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $7W8i8 = parcelRequire("7W8i8");

const $9c02a77990f99958$var$logger = (0, $7W8i8.getLogger)('SmartCreateFeedbackBanner');
const $9c02a77990f99958$var$MAX_DISMISS_COUNT = 3;
const $9c02a77990f99958$var$ONE_DAY_IN_MS = 86400000; // 24 hours in milliseconds
const $9c02a77990f99958$var$TWO_WEEKS_IN_MS = 14 * $9c02a77990f99958$var$ONE_DAY_IN_MS; // 2 weeks in milliseconds
const $9c02a77990f99958$var$STORAGE_KEY = (0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SMART_CREATE_FEEDBACK_BANNER_LAST_DISMISSED;
const $9c02a77990f99958$var$DISMISSAL_PERIODS = [
    0,
    $9c02a77990f99958$var$ONE_DAY_IN_MS,
    $9c02a77990f99958$var$TWO_WEEKS_IN_MS
];
const $9c02a77990f99958$var$getLocalStorageItem = ()=>{
    try {
        const itemString = (0, $17wUi.confluenceLocalStorageInstance).getItem($9c02a77990f99958$var$STORAGE_KEY);
        if (!itemString) return {};
        const item = JSON.parse(itemString);
        if (typeof item === 'object' && item !== null && !Array.isArray(item) && (typeof item.time === 'number' || item.time === undefined) && (typeof item.count === 'number' || item.count === undefined)) return item;
    } catch (error) {
        $9c02a77990f99958$var$logger.error`Error parsing local storage key(${$9c02a77990f99958$var$STORAGE_KEY}): ${error}`;
    }
    (0, $17wUi.confluenceLocalStorageInstance).setItem($9c02a77990f99958$var$STORAGE_KEY, JSON.stringify({}));
    return {};
};
const $9c02a77990f99958$var$updateLocalStorageItem = (item)=>{
    try {
        (0, $17wUi.confluenceLocalStorageInstance).setItem($9c02a77990f99958$var$STORAGE_KEY, JSON.stringify(item));
    } catch (error) {
        $9c02a77990f99958$var$logger.error`Error setting local storage key(${$9c02a77990f99958$var$STORAGE_KEY}): ${error}`;
    }
};
const $9c02a77990f99958$export$d9853b07d3a8476b = ()=>{
    const { time: time = 0, count: count = 0 } = $9c02a77990f99958$var$getLocalStorageItem();
    const currentTime = Date.now();
    if (count >= $9c02a77990f99958$var$MAX_DISMISS_COUNT) return true; // Permanently dismissed
    const requiredDuration = $9c02a77990f99958$var$DISMISSAL_PERIODS[count] ?? 0;
    return currentTime - time < requiredDuration;
};
const $9c02a77990f99958$var$updateBannerDismissal = (count)=>{
    const item = $9c02a77990f99958$var$getLocalStorageItem();
    const currentTime = Date.now();
    item.time = currentTime;
    item.count = count;
    $9c02a77990f99958$var$updateLocalStorageItem(item);
};
const $9c02a77990f99958$export$775e775a1048dbdb = ()=>{
    const item = $9c02a77990f99958$var$getLocalStorageItem();
    const newCount = (item.count ?? 0) + 1;
    if (newCount >= $9c02a77990f99958$var$MAX_DISMISS_COUNT) $9c02a77990f99958$export$f6b01b0b3935b76b();
    else $9c02a77990f99958$var$updateBannerDismissal(newCount);
};
const $9c02a77990f99958$export$f6b01b0b3935b76b = ()=>{
    $9c02a77990f99958$var$updateBannerDismissal($9c02a77990f99958$var$MAX_DISMISS_COUNT);
};


const $0c1a4cacd3ffcce5$var$feedbackBannerStyles = (0, $ecnYn.xcss)({
    padding: 'space.050',
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    backgroundColor: 'elevation.surface.sunken',
    color: 'color.text.subtle'
});
const $0c1a4cacd3ffcce5$var$feedbackBannerTopBorderStyles = (0, $ecnYn.xcss)({
    borderTop: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
});
const $0c1a4cacd3ffcce5$var$feedbackBannerLayerStyles = (0, $ecnYn.xcss)({
    zIndex: 'modal'
});
const $0c1a4cacd3ffcce5$var$feedbackBannerMessageStyles = (0, $ecnYn.xcss)({
    gridArea: 'message'
});
const $0c1a4cacd3ffcce5$var$closeButtonStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifySelf: 'end',
    gridArea: 'close'
});
const $0c1a4cacd3ffcce5$var$bannerStyles = (0, $ecnYn.xcss)({
    width: '100%'
});
const $0c1a4cacd3ffcce5$var$i18n = (0, $cgtv4.defineMessages)({
    bannerMessage: {
        id: "editor-action-bar.feedback-banner.message.smart-create",
        defaultMessage: "This content was created with Rovo! We\u2019d love to hear what you think. <link>Share feedback</link>"
    },
    bannerClose: {
        id: "editor-action-bar.feedback-banner.close.smart-create",
        defaultMessage: "Close"
    }
});
const $0c1a4cacd3ffcce5$var$SmartCreateFeedbackBannerQuery = (0, $gRzR4.default);
const $0c1a4cacd3ffcce5$var$SMART_CREATE_GENERATED_BY = 'ROVO_SMART_CREATION';
const $0c1a4cacd3ffcce5$var$SmartCreateFeedbackBannerComponent = ({ contentType: contentType })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [showBanner, setShowBanner] = (0, $42omo.useState)(!(0, $9c02a77990f99958$export$d9853b07d3a8476b)());
    const [showFeedbackCollector, setShowFeedbackCollector] = (0, $42omo.useState)(false);
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const contentMode = contentType === 'page' ? pageMode : undefined;
    const { areBannersHidden: areBannersHidden } = (0, $i4dNk.useCfind4473CreationFocusedNav)(); // simplify the nav for D0 experience
    const handleOnClickClose = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'smartCreateFeedbackClose',
                source: 'smartCreateFeedbackBanner',
                attributes: {
                    contentType: contentType,
                    contentMode: contentMode
                }
            }
        }).fire();
        (0, $9c02a77990f99958$export$775e775a1048dbdb)();
        setShowBanner(false);
    }, [
        createAnalyticsEvent,
        contentType,
        contentMode
    ]);
    const handleOnClickFeedbackButton = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'smartCreateFeedbackShare',
                source: 'smartCreateFeedbackBanner',
                attributes: {
                    contentType: contentType,
                    contentMode: contentMode
                }
            }
        }).fire();
        setShowFeedbackCollector(true);
    }, [
        createAnalyticsEvent,
        contentType,
        contentMode
    ]);
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($0c1a4cacd3ffcce5$var$SmartCreateFeedbackBannerQuery, {
        variables: {
            contentId: contentId ?? ''
        },
        skip: !contentId || !userId || areBannersHidden
    });
    const { singleContent: singleContent } = data || {};
    const contentProperties = singleContent?.contentProperties;
    const isGeneratedBySmartCreate = contentProperties?.draft?.generatedBy === $0c1a4cacd3ffcce5$var$SMART_CREATE_GENERATED_BY || contentProperties?.latest?.generatedBy === $0c1a4cacd3ffcce5$var$SMART_CREATE_GENERATED_BY;
    const createdByCurrentUser = userId ? singleContent?.creatorId === userId : false;
    const shouldShowFeedbackBanner = isGeneratedBySmartCreate && createdByCurrentUser;
    (0, $42omo.useEffect)(()=>{
        if (showBanner && shouldShowFeedbackBanner && !loading && !areBannersHidden) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'smartCreateFeedbackBanner',
                attributes: {
                    contentType: contentType,
                    contentMode: contentMode
                }
            }
        }).fire();
    }, [
        showBanner,
        shouldShowFeedbackBanner,
        createAnalyticsEvent,
        contentType,
        contentMode,
        loading,
        areBannersHidden
    ]);
    // D0 experiment for simplifying the first day UX
    if (areBannersHidden || loading || !shouldShowFeedbackBanner) return null;
    return showBanner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": "smart-create-feedback-banner",
        ...ssrPlaceholderIdProp,
        css: $0c1a4cacd3ffcce5$var$bannerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cwkWT.default), {
        templateAreas: [
            'empty message close'
        ],
        templateColumns: "1fr auto 1fr",
        xcss: [
            $0c1a4cacd3ffcce5$var$feedbackBannerStyles,
            $0c1a4cacd3ffcce5$var$feedbackBannerLayerStyles,
            (contentMode === 'view' || contentMode === 'live') && $0c1a4cacd3ffcce5$var$feedbackBannerTopBorderStyles
        ],
        testId: "smart-create-feedback-banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        alignInline: "center",
        alignBlock: "center",
        xcss: $0c1a4cacd3ffcce5$var$feedbackBannerMessageStyles
    }, !(0, $9wGTI.fg)('aifc_onboarding_ga_enabled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ibDKJ.AILabsLozenge), null) : !(0, $6mKj3.expValEquals)('cc-aifc-databases-experiment', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ibDKJ.AILabsLozenge), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$0c1a4cacd3ffcce5$var$i18n.bannerMessage,
        values: {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                    appearance: "link",
                    spacing: "none",
                    onClick: handleOnClickFeedbackButton
                }, chunks)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $0c1a4cacd3ffcce5$var$closeButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: formatMessage($0c1a4cacd3ffcce5$var$i18n.bannerClose),
        onClick: handleOnClickClose
    }))), showFeedbackCollector && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fHyH9.SmartCreateFeedback), {
        variant: (0, $5z48q.SmartCreateFeedbackVariant).CREATE_WITH_ROVO,
        onClose: ()=>setShowFeedbackCollector(false),
        onSubmit: ()=>{
            setShowFeedbackCollector(false);
            (0, $9c02a77990f99958$export$f6b01b0b3935b76b)();
        },
        tenantId: cloudId,
        additionalFields: {
            'Entry Point': 'Confluence SmartCreateFeedbackBanner',
            contentType: contentType,
            contentMode: contentMode
        }
    })) : null;
};
const $0c1a4cacd3ffcce5$export$3f62640f5a93948 = (0, $7aRa9.withFlags)($0c1a4cacd3ffcce5$var$SmartCreateFeedbackBannerComponent);
module.exports["SmartCreateFeedbackBanner"] = $0c1a4cacd3ffcce5$export$3f62640f5a93948;

});

parcelRegister("gRzR4", function(module, exports) {
/**
 * @generated SignedSource<<6050f94e69307ca99b98b624b9d08371>>
 * @relayHash a2b7f78fbc7a4e9ecead01083cfe8f24
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2f8168270ed250fa33f38610fa3b20029664886f16e5db1184bbca7a9821266
const $7836e6257492ac35$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "generatedBy"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "ScalarField",
                    "name": "creatorId"
                },
                {
                    "concreteType": "ContentProperties",
                    "kind": "LinkedField",
                    "name": "contentProperties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DraftContentProperties",
                            "kind": "LinkedField",
                            "name": "draft",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        },
                        {
                            "concreteType": "PublishedContentProperties",
                            "kind": "LinkedField",
                            "name": "latest",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SmartCreateFeedbackBannerQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SmartCreateFeedbackBannerQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "a2b7f78fbc7a4e9ecead01083cfe8f24",
            "id": "e2f8168270ed250fa33f38610fa3b20029664886f16e5db1184bbca7a9821266",
            "metadata": {},
            "name": "SmartCreateFeedbackBannerQuery",
            "operationKind": "query",
            "text": "query SmartCreateFeedbackBannerQuery($contentId:ID!){singleContent(id:$contentId){title,id,type,creatorId,contentProperties{draft{generatedBy},latest{generatedBy}}}}"
        }
    };
}();
$7836e6257492ac35$var$node.hash = "4f4f276100c2961c7227836999fc58e5";
var $7836e6257492ac35$export$2e2bcd8739ae039 = $7836e6257492ac35$var$node;
module.exports["default"] = $7836e6257492ac35$export$2e2bcd8739ae039;

});

parcelRegister("fHyH9", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $biiXa = parcelRequire("biiXa");


var $1uunn = parcelRequire("1uunn");


var $8qaEU = parcelRequire("8qaEU");


var $6tcD9 = parcelRequire("6tcD9");


var $l3BrO = parcelRequire("l3BrO");


var $5z48q = parcelRequire("5z48q");

const $67831e29f8762387$var$ANALYTICS_CHANNEL = 'aiMate';
const $67831e29f8762387$var$ENTRYPOINT_ID = '63867aef-06e5-4520-855f-4d29e062f22c';
const $67831e29f8762387$var$FEEDBACK_CONTEXT_FIELD_ID = 'customfield_10047';
const $67831e29f8762387$var$constructFeedbackContext = (additionalFields, aaid, tenantId)=>{
    const userAgent = navigator.userAgent;
    const screenResolution = `${window.screen.width} x ${window.screen.height}`;
    const feedbackContext = {
        'User-Agent': userAgent,
        'Screen Resolution': screenResolution,
        'User Account Id': aaid ?? 'unknown',
        'Tenant Id': tenantId ?? 'unknown',
        /* Other context fields will have to be passed in as props, since there aren't public hooks to get these.
    Environment: metadata.environment ?? '',
    Product: metadata.product ?? '',
    Edition: metadata.edition ?? '',
    */ ...additionalFields
    };
    const feedbackContextStr = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${value}`).join('\n');
    return [
        {
            id: $67831e29f8762387$var$FEEDBACK_CONTEXT_FIELD_ID,
            value: feedbackContextStr
        }
    ];
};
const $67831e29f8762387$var$getFeedbackConfig = (variant)=>{
    switch(variant){
        case (0, $5z48q.SmartCreateFeedbackVariant).CREATE_WITH_ROVO:
            return {
                feedbackTitle: (0, $l3BrO.messages).feedbackTitle,
                rateExperience: (0, $l3BrO.messages).rateExperience
            };
        case (0, $5z48q.SmartCreateFeedbackVariant).ROVO:
            return {
                feedbackTitle: (0, $l3BrO.messages).feedbackTitleNoCreate,
                rateExperience: (0, $l3BrO.messages).rateExperienceNoCreate
            };
        case (0, $5z48q.SmartCreateFeedbackVariant).CREATE_WITH_ROVO_FROM_JIRA:
            return {
                feedbackTitle: (0, $l3BrO.messages).feedbackTitle,
                rateExperience: (0, $l3BrO.messages).rateExperience
            };
    }
};
function $67831e29f8762387$export$35c06614b8d216da(props) {
    const { name: name, aaid: aaid, email: email } = (0, $1uunn.useProfileController)();
    return /*#__PURE__*/ (0, $l998X.jsx)($67831e29f8762387$export$4a210f0e33a62fe0, {
        name: name,
        aaid: aaid,
        email: email,
        ...props
    });
}
function $67831e29f8762387$export$4a210f0e33a62fe0({ variant: variant = (0, $5z48q.SmartCreateFeedbackVariant).CREATE_WITH_ROVO, entrypointId: entrypointId = $67831e29f8762387$var$ENTRYPOINT_ID, onClose: // Default to Confluence AIFC's entrypoint to avoid making changes to Confluence packages
onClose, onSubmit: onSubmit, tenantId: tenantId, additionalFields: additionalFields = {}, name: name, aaid: aaid, email: email }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { feedbackTitle: feedbackTitle, rateExperience: rateExperience } = $67831e29f8762387$var$getFeedbackConfig(variant);
    const categories = (0, $42omo.useMemo)(()=>[
            {
                id: 'performance',
                text: formatMessage((0, $l3BrO.messages).categoryPerformance)
            },
            {
                id: 'response-quality',
                text: formatMessage((0, $l3BrO.messages).categoryResponseQuality)
            },
            {
                id: 'user-experience',
                text: formatMessage((0, $l3BrO.messages).categoryUserExperience)
            },
            {
                id: 'other',
                text: formatMessage((0, $l3BrO.messages).categoryOther)
            }
        ], [
        formatMessage
    ]);
    const [experienceRating, setExperienceRating] = (0, $42omo.useState)(undefined);
    const [selectedCategory, setSelectedCategory] = (0, $42omo.useState)(undefined);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            eventType: 'screen',
            name: 'smartCreateFeedbackCollector',
            attributes: {
                feedbackVariant: variant
            },
            tags: [
                'atlaskit'
            ]
        }).fire($67831e29f8762387$var$ANALYTICS_CHANNEL);
    }, [
        variant,
        createAnalyticsEvent
    ]);
    const onCloseWithAnalytics = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'closed',
            actionSubject: 'smartCreateFeedbackCollector',
            attributes: {
                feedbackVariant: variant
            },
            tags: [
                'atlaskit'
            ]
        }).fire($67831e29f8762387$var$ANALYTICS_CHANNEL);
        onClose();
    }, [
        onClose,
        variant,
        createAnalyticsEvent
    ]);
    const onSubmitWithAnalytics = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'submitted',
            actionSubject: 'smartCreateFeedbackCollector',
            attributes: {
                feedbackVariant: variant,
                experienceRating: experienceRating,
                selectedCategory: selectedCategory
            },
            tags: [
                'atlaskit'
            ]
        }).fire($67831e29f8762387$var$ANALYTICS_CHANNEL);
        onSubmit();
    }, [
        onSubmit,
        variant,
        experienceRating,
        selectedCategory,
        createAnalyticsEvent
    ]);
    const customFields = {
        'Feedback Variant': variant,
        'Selected Category': selectedCategory ?? '',
        'Experience Rating': experienceRating ?? '',
        'Experience Rating Number': experienceRating !== undefined ? (0, $6tcD9.ExperienceRatingToNumber)[experienceRating] : '',
        ...additionalFields
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $biiXa.default), {
        onClose: onCloseWithAnalytics,
        onSubmit: onSubmitWithAnalytics,
        atlassianAccountId: aaid,
        name: name,
        email: email,
        entrypointId: entrypointId,
        feedbackTitle: formatMessage(feedbackTitle),
        showTypeField: false,
        customTextAreaLabel: formatMessage((0, $l3BrO.messages).summaryTitle),
        customContent: /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6tcD9.EmojiRatingSelector), {
                    rating: experienceRating,
                    setRating: setExperienceRating,
                    label: formatMessage(rateExperience)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $8qaEU.CategoryPillGroup), {
                    categories: categories,
                    selectedCategory: selectedCategory,
                    setSelectedCategory: setSelectedCategory,
                    label: formatMessage((0, $l3BrO.messages).categoryTitle)
                })
            ]
        }),
        disableSubmitButton: experienceRating === undefined,
        additionalFields: $67831e29f8762387$var$constructFeedbackContext(customFields, aaid, tenantId)
    });
}
module.exports["SmartCreateFeedback"] = $67831e29f8762387$export$35c06614b8d216da;

});

parcelRegister("1uunn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");


var $8gGM0 = parcelRequire("8gGM0");

const $90ef72367fab294b$var$fetchProfileData = (0, $2XqLN.default)(async ()=>{
    const data = await (0, $8gGM0.me)();
    return {
        aaid: data.account_id,
        name: data.name || '',
        displayName: data.nickname,
        avatarUrl: data.picture,
        email: data.email
    };
});
const $90ef72367fab294b$export$3c814b55c7cbb1fb = (0, $42omo.createContext)(null);
const $90ef72367fab294b$var$emptyProfileData = {
    name: '',
    displayName: '',
    avatarUrl: ''
};
const $90ef72367fab294b$export$68afc71177137005 = (preFetchedProfileData)=>{
    const [profileData, setProfileData] = (0, $42omo.useState)($90ef72367fab294b$var$emptyProfileData);
    const profileContextData = (0, $42omo.useContext)($90ef72367fab294b$export$3c814b55c7cbb1fb);
    (0, $42omo.useEffect)(()=>{
        if (preFetchedProfileData) setProfileData(preFetchedProfileData);
        else if (profileContextData) setProfileData(profileContextData);
        else $90ef72367fab294b$var$fetchProfileData().then((data)=>setProfileData(data)).catch(()=>setProfileData($90ef72367fab294b$var$emptyProfileData));
    }, [
        setProfileData,
        profileContextData,
        preFetchedProfileData
    ]);
    return profileData;
};
module.exports["useProfileController"] = $90ef72367fab294b$export$68afc71177137005;

});

parcelRegister("8gGM0", function(module, exports) {

var $8Igpw = parcelRequire("8Igpw");

const $2f3ab166c93f3263$export$3e32638432616b6 = async ()=>{
    const response = await (0, $8Igpw.performHttpFetch)({
        path: '/gateway/api/me',
        options: {
            method: 'GET'
        }
    });
    return response;
};
module.exports["me"] = $2f3ab166c93f3263$export$3e32638432616b6;

});

parcelRegister("8qaEU", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $fb3kw = parcelRequire("fb3kw");


var $1s5hv = parcelRequire("1s5hv");

var $fVUfS = parcelRequire("fVUfS");

// This file is based on confluence/next/packages/object-sidebar-components/src/sidebar-buttons/FeedbackCollectorButton.tsx
const $0f6c1ac81be85b26$var$styles = {
    categoryPillGroupContainer: "_zulpu2gc _1e0c1txw _2lx2vrvc _1bah1y6m _1n261g80 _otyrpxbi",
    categoryPill: "_11c8fhey _2rko1rr0 _1h6d1j28 _189ee4h9 _1dqonqa1 _4t3izwfg _1bah1h6o _4cvr1h6o _uiztglyw _o5721q9c _vchhusvi _syazi7uo _bfhki8nm _ca0q12x7 _n3td12x7 _u5f3utpp _19bvutpp _irr3plhp",
    categoryPillSelected: "_1h6dq98m _syaz6x5g _bfhk15s3 _irr3ufnl"
};
const $0f6c1ac81be85b26$export$7dad6a6503835f40 = ({ categories: categories, selectedCategory: selectedCategory, setSelectedCategory: setSelectedCategory, label: label })=>{
    const onCategoryButtonClick = (0, $42omo.useCallback)((category)=>(e)=>{
            e.preventDefault();
            setSelectedCategory(category);
        }, [
        setSelectedCategory
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
        label: label,
        isRequired: false,
        name: "category-group",
        id: "category-group",
        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                    "data-name": fieldProps.id,
                    xcss: $0f6c1ac81be85b26$var$styles.categoryPillGroupContainer,
                    role: "radiogroup",
                    children: categories.map((category)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                            role: "radio",
                            "aria-checked": category.id === selectedCategory,
                            "data-name": category.text,
                            "data-value": category.id,
                            onClick: onCategoryButtonClick(category.id),
                            xcss: (0, $1Whri.cx)($0f6c1ac81be85b26$var$styles.categoryPill, category.id === selectedCategory && $0f6c1ac81be85b26$var$styles.categoryPillSelected),
                            children: category.text
                        }, category.id))
                })
            })
    });
};
module.exports["CategoryPillGroup"] = $0f6c1ac81be85b26$export$7dad6a6503835f40;

});

parcelRegister("6tcD9", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");


var $gQhRa = parcelRequire("gQhRa");

var $fb3kw = parcelRequire("fb3kw");


var $1s5hv = parcelRequire("1s5hv");

var $fVUfS = parcelRequire("fVUfS");


var $f6b57 = parcelRequire("f6b57");

const $f453c89bfd60042f$var$styles = {
    emojiSelectionContainer: "_zulpu2gc _1e0c1txw _2lx2vrvc _1bah1y6m _otyrpxbi",
    emojiButton: "_11c812ln _2rko12b0 _1h6d1j28 _189ee4h9 _1dqonqa1 _bfhk1j28 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _irr3plhp",
    emojiButtonSelected: "_1h6d1v1w _bfhk15s3 _irr3ufnl"
};
var $f453c89bfd60042f$export$d51aadc3a803b62 = /*#__PURE__*/ function(ExperienceRating) {
    ExperienceRating["VeryDissatisfied"] = "Very dissatisfied";
    ExperienceRating["Dissatisfied"] = "Dissatisfied";
    ExperienceRating["Neutral"] = "Neutral";
    ExperienceRating["Satisfied"] = "Satisfied";
    ExperienceRating["VerySatisfied"] = "Very satisfied";
    return ExperienceRating;
}({});
const $f453c89bfd60042f$export$1224208ff0eb2a38 = {
    ["Very dissatisfied"]: 1,
    ["Dissatisfied"]: 2,
    ["Neutral"]: 3,
    ["Satisfied"]: 4,
    ["Very satisfied"]: 5
};
const $f453c89bfd60042f$var$OPTION_DATA = [
    {
        emoji: "\uD83D\uDE20",
        experienceRating: "Very dissatisfied"
    },
    {
        emoji: "\u2639\uFE0F",
        experienceRating: "Dissatisfied"
    },
    {
        emoji: "\uD83D\uDE10",
        experienceRating: "Neutral"
    },
    {
        emoji: "\uD83D\uDE42",
        experienceRating: "Satisfied"
    },
    {
        emoji: "\uD83D\uDE03",
        experienceRating: "Very satisfied"
    }
];
const $f453c89bfd60042f$export$dfef634eb7f87ea8 = ({ rating: rating, setRating: setRating, label: label })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const onEmojiButtonClick = (0, $42omo.useCallback)((option, fieldProps)=>(e)=>{
            e.preventDefault();
            setRating(option.experienceRating);
            fieldProps.onChange(option.experienceRating);
        }, [
        setRating
    ]);
    const validateRating = (value)=>{
        if (!value) return formatMessage((0, $f6b57.messages).validationErrorRatingRequired);
        return undefined;
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
        label: label,
        isRequired: true,
        name: "rate-experience",
        id: "rate-experience",
        validate: validateRating,
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                        "data-name": fieldProps.id,
                        xcss: $f453c89bfd60042f$var$styles.emojiSelectionContainer,
                        role: "radiogroup",
                        children: $f453c89bfd60042f$var$OPTION_DATA.map((option)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                                role: "radio",
                                "aria-checked": rating === option.experienceRating,
                                "data-name": option.experienceRating,
                                "data-value": option.experienceRating,
                                testId: `emoji-rating-${$f453c89bfd60042f$export$1224208ff0eb2a38[option.experienceRating]}`,
                                onClick: onEmojiButtonClick(option, fieldProps),
                                xcss: (0, $1Whri.cx)($f453c89bfd60042f$var$styles.emojiButton, rating === option.experienceRating && $f453c89bfd60042f$var$styles.emojiButtonSelected),
                                children: option.emoji
                            }, option.experienceRating))
                    }),
                    error && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                        children: error
                    })
                ]
            })
    });
};
module.exports["ExperienceRatingToNumber"] = $f453c89bfd60042f$export$1224208ff0eb2a38;
module.exports["EmojiRatingSelector"] = $f453c89bfd60042f$export$dfef634eb7f87ea8;

});

parcelRegister("f6b57", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $53dbda8659203e20$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    validationErrorRatingRequired: {
        id: "smart-create-feedback.emoji-rating-selector.validation.rating.required",
        defaultMessage: "Please select a rating before submitting"
    }
});
module.exports["messages"] = $53dbda8659203e20$export$defe85febe8b728c;

});

parcelRegister("l3BrO", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $78ec0b23f6329732$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    feedbackTitle: {
        id: "smart-create-feedback.feedback-title",
        defaultMessage: "Help us improve Create with Rovo"
    },
    rateExperience: {
        id: "smart-create-feedback.emoji-rating-selector.label",
        defaultMessage: "Please rate your experience with Create with Rovo:"
    },
    feedbackTitleNoCreate: {
        id: "smart-create-feedback.feedback-title-no-create",
        defaultMessage: "Help us improve Rovo"
    },
    rateExperienceNoCreate: {
        id: "smart-create-feedback.emoji-rating-selector.label-no-create",
        defaultMessage: "Please rate your experience with Rovo:"
    },
    summaryTitle: {
        id: "smart-create-feedback.summary-title",
        defaultMessage: "Tell us more about your experience:"
    },
    categoryTitle: {
        id: "smart-create-feedback.category-title",
        defaultMessage: "What category best describes your feedback? (optional)"
    },
    categoryPerformance: {
        id: "smart-create-feedback.category.performance",
        defaultMessage: "Performance"
    },
    categoryResponseQuality: {
        id: "smart-create-feedback.category.response-quality",
        defaultMessage: "Response quality"
    },
    categoryUserExperience: {
        id: "smart-create-feedback.category.user-experience",
        defaultMessage: "User experience"
    },
    categoryOther: {
        id: "smart-create-feedback.category.other",
        defaultMessage: "Other"
    }
});
module.exports["messages"] = $78ec0b23f6329732$export$defe85febe8b728c;

});

parcelRegister("5z48q", function(module, exports) {
var $b7edf7df99d5989b$export$cc1cd6888a5f186c = /*#__PURE__*/ function(SmartCreateFeedbackVariant) {
    SmartCreateFeedbackVariant["ROVO"] = "rovo";
    SmartCreateFeedbackVariant["CREATE_WITH_ROVO"] = "create-with-rovo";
    SmartCreateFeedbackVariant["CREATE_WITH_ROVO_FROM_JIRA"] = "create-with-rovo-from-jira";
    return SmartCreateFeedbackVariant;
}({});
module.exports["SmartCreateFeedbackVariant"] = $b7edf7df99d5989b$export$cc1cd6888a5f186c;

});

parcelRegister("ibDKJ", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $cOrQJ = parcelRequire("cOrQJ");


var $3gadb = parcelRequire("3gadb");

var $afneb = parcelRequire("afneb");


var $36Swo = parcelRequire("36Swo");

const $e5b02ec9368d4295$var$i18n = (0, $cgtv4.defineMessages)({
    tooltip: {
        id: "ai-common.ai-labs-lozenge.tooltip",
        defaultMessage: "Beta: This feature is still in development."
    }
});
const $e5b02ec9368d4295$var$lozengeStyles = {
    lozenge: "_2rko12b0 _18zr1b66 _1e0c1txw _4cvr1h6o _1bah1h6o",
    tooltip: "_2rko12b0 _11c8wadc _vchhusvi _p12f7l9q _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna"
};
const $e5b02ec9368d4295$var$gradientWaveKeyframes = null;
const $e5b02ec9368d4295$var$lozengeAnimatedBorder = null; // Using a custom tooltip is a workaround to avoid odd spacing due to default styles,
// primarily for the English locale
const $e5b02ec9368d4295$var$CustomTooltip = /*#__PURE__*/ (0, $42omo.forwardRef)(function CustomTooltip({ children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $afneb.default), {
        ...props,
        ref: ref,
        className: (0, $gMc0m.default)([
            $e5b02ec9368d4295$var$lozengeStyles.tooltip
        ]),
        children: children
    });
});
const $e5b02ec9368d4295$export$48aba4499a97f6bf = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)(); // We don't want to i18n the term 'AI Labs' because it is the branding name
    // and should be the same across all languages
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        component: $e5b02ec9368d4295$var$CustomTooltip,
        content: formatMessage($e5b02ec9368d4295$var$i18n.tooltip),
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            "data-testid": "ai-labs-lozenge",
            className: (0, $gMc0m.default)([
                $e5b02ec9368d4295$var$lozengeStyles.lozenge,
                "_2rko12b0 _18zr1b66 _kqswh2mm _bfhksm61 _1e0c1txw _4cvr1h6o _1bah1h6o _1pbyidpf _1tesidpf _rfx312b0 _1414t94y _p7f0t94y _7gpxt94y _syayt94y _1s6kyrfl _16qq1ajn _1kt9b3bt _1cs8stnw _1ankm4tz _12a1epuu _x5brkvto _13sb1p67 _dsq4glyw _1g0v1mrw"
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                grow: "hug",
                space: "space.025",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $36Swo.LabsIcon), {
                        darkMode: colorMode === 'dark'
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            weight: "semibold",
                            color: "color.text",
                            children: "LABS"
                        })
                    })
                ]
            })
        })
    });
};
module.exports["AILabsLozenge"] = $e5b02ec9368d4295$export$48aba4499a97f6bf;

});

parcelRegister("36Swo", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $ffeb61eca9109eeb$export$36be37b392de5213 = ({ darkMode: darkMode = false })=>{
    return darkMode ? /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "8",
        viewBox: "0 0 10 8",
        fill: "none",
        "data-testid": "ai-labs-icon-dark",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                clipPath: "url(#clip0_1466_13761)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M8.66319 5.51003C6.1943 4.31624 5.47305 4.13786 4.43279 4.13786C3.21221 4.13786 2.17195 4.64556 1.24264 6.07262L1.09007 6.30589C0.96524 6.498 0.9375 6.5666 0.9375 6.64893C0.9375 6.73127 0.979111 6.79987 1.13168 6.89593L2.69901 7.87017C2.78223 7.92506 2.85159 7.9525 2.92094 7.9525C3.00416 7.9525 3.05964 7.91133 3.14286 7.78784L3.39252 7.40363C3.78089 6.8136 4.12764 6.62149 4.57149 6.62149C4.95985 6.62149 5.41757 6.73127 5.98625 7.0057L7.62293 7.77412C7.78937 7.85645 7.96968 7.81528 8.0529 7.62318L8.82963 5.92168C8.91286 5.72958 8.85737 5.60608 8.66319 5.51003ZM1.46457 2.50497C3.93346 3.69876 4.65471 3.87714 5.69497 3.87714C6.91555 3.87714 7.95581 3.36944 8.88512 1.94238L9.03769 1.70911C9.16252 1.517 9.19026 1.4484 9.19026 1.36607C9.19026 1.28373 9.14865 1.21513 8.99608 1.11907L7.42875 0.14483C7.34552 0.0899435 7.27617 0.0625 7.20682 0.0625C7.1236 0.0625 7.06812 0.103665 6.9849 0.227161L6.73524 0.61137C6.34687 1.2014 6.00012 1.39351 5.55627 1.39351C5.16791 1.39351 4.71019 1.28373 4.14151 1.0093L2.50483 0.240883C2.33839 0.158552 2.15808 0.199717 2.07486 0.391822L1.29812 2.09332C1.2149 2.28542 1.27038 2.40892 1.46457 2.50497Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_1466_13761",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "8.25276",
                        height: "7.89",
                        fill: "white",
                        transform: "translate(0.9375 0.0625)"
                    })
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "8",
        viewBox: "0 0 10 8",
        fill: "none",
        "data-testid": "ai-labs-icon",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                clipPath: "url(#clip0_1352_45568)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M8.66319 5.51003C6.1943 4.31624 5.47305 4.13786 4.43279 4.13786C3.21221 4.13786 2.17195 4.64556 1.24264 6.07262L1.09007 6.30589C0.96524 6.498 0.9375 6.5666 0.9375 6.64893C0.9375 6.73127 0.979111 6.79987 1.13168 6.89593L2.69901 7.87017C2.78223 7.92506 2.85159 7.9525 2.92094 7.9525C3.00416 7.9525 3.05964 7.91133 3.14286 7.78784L3.39252 7.40363C3.78089 6.8136 4.12764 6.62149 4.57149 6.62149C4.95985 6.62149 5.41757 6.73127 5.98625 7.0057L7.62293 7.77412C7.78937 7.85645 7.96968 7.81528 8.0529 7.62318L8.82963 5.92168C8.91286 5.72958 8.85737 5.60608 8.66319 5.51003ZM1.46457 2.50497C3.93346 3.69876 4.65471 3.87714 5.69497 3.87714C6.91555 3.87714 7.95581 3.36944 8.88512 1.94238L9.03769 1.70911C9.16252 1.517 9.19026 1.4484 9.19026 1.36607C9.19026 1.28373 9.14865 1.21513 8.99608 1.11907L7.42875 0.14483C7.34552 0.0899435 7.27617 0.0625 7.20682 0.0625C7.1236 0.0625 7.06812 0.103665 6.9849 0.227161L6.73524 0.61137C6.34687 1.2014 6.00012 1.39351 5.55627 1.39351C5.16791 1.39351 4.71019 1.28373 4.14151 1.0093L2.50483 0.240883C2.33839 0.158552 2.15808 0.199717 2.07486 0.391822L1.29812 2.09332C1.2149 2.28542 1.27038 2.40892 1.46457 2.50497Z",
                    fill: "#1E1F21"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_1352_45568",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "8.25276",
                        height: "7.89",
                        fill: "white",
                        transform: "translate(0.9375 0.0625)"
                    })
                })
            })
        ]
    });
};
module.exports["LabsIcon"] = $ffeb61eca9109eeb$export$36be37b392de5213;

});

parcelRegister("luv00", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5nSna = parcelRequire("5nSna");

function $8a88875ffe13fd4c$export$30b62f74ca853d7d() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
}
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("i4dNk", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $dBcar = parcelRequire("dBcar");


var $ivb8S = parcelRequire("ivb8S");

const $0451aea256d3610a$export$5ff0b879ab65d0b0 = 'd1';
const $0451aea256d3610a$export$46c1c92549715335 = 'loading';
const $0451aea256d3610a$export$61c0af74ec47d243 = 'd0';
const $0451aea256d3610a$export$f883a24d5edde77c = 'none';
const $0451aea256d3610a$export$a226a5c24cc00b77 = (updateState = false)=>{
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { cohort: cohort, delayInMinutes: delayInMinutes } = $0451aea256d3610a$var$getExperimentData();
    const hasUpdatedState = (0, $42omo.useRef)(false);
    const isInExperimentControl = cohort !== 'treatment';
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT),
        (0, $dBcar.CREATION_FOCUSED_NAV_START_TIME)
    ], isInExperimentControl);
    const spotlightShown = ()=>{
        setOnboardingState({
            key: (0, $dBcar.CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT),
            value: 'false'
        });
    };
    if (isInExperimentControl) return {
        isSpotlightVisible: false,
        areBannersHidden: false,
        navCustomization: $0451aea256d3610a$export$f883a24d5edde77c
    };
    if (onboardingStateLoading) // Simplify nav and hide banners while loading, to minimize flashing
    return {
        isSpotlightVisible: false,
        areBannersHidden: true,
        navCustomization: $0451aea256d3610a$export$46c1c92549715335
    };
    if (onboardingStateError) // Control behavior if there are any errors
    return {
        isSpotlightVisible: false,
        areBannersHidden: false,
        navCustomization: $0451aea256d3610a$export$f883a24d5edde77c
    };
    const { shouldShowSpotlight: shouldShowSpotlight, startTime: startTime } = (0, $ivb8S.deserializeState)(onboardingStateData);
    if ($0451aea256d3610a$var$isSiteOlderThanDelay(delayInMinutes, startTime)) {
        if (shouldShowSpotlight) // Spotlight ready to show --> Show spotlight, bring nav features back, but don't bring banners back
        return {
            isSpotlightVisible: true,
            areBannersHidden: true,
            navCustomization: $0451aea256d3610a$export$5ff0b879ab65d0b0,
            onSpotlightShown: spotlightShown
        };
        else if (shouldShowSpotlight === false) // Spotlight has already shown --> Don't show spotlight, bring nav features back, but don't bring banners back
        return {
            isSpotlightVisible: false,
            areBannersHidden: true,
            navCustomization: $0451aea256d3610a$export$5ff0b879ab65d0b0
        };
        // This account was created before the experiment started, so we won't change anything even though statsig returned "treatment"
        return {
            isSpotlightVisible: false,
            areBannersHidden: false,
            navCustomization: $0451aea256d3610a$export$f883a24d5edde77c
        };
    } else if (shouldShowSpotlight === undefined && updateState && !hasUpdatedState.current) {
        hasUpdatedState.current = true;
        setOnboardingState({
            key: (0, $dBcar.CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT),
            value: 'true'
        });
    }
    return {
        isSpotlightVisible: false,
        areBannersHidden: true,
        navCustomization: $0451aea256d3610a$export$61c0af74ec47d243
    };
};
const $0451aea256d3610a$var$getExperimentData = ()=>{
    // eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure
    const [expConfig] = (0, $6mKj3.UNSAFE_noExposureExp)('cfind-4473-creation-focused-nav'); // Experiment exposure is fired in the backend
    const cohort = expConfig.get('cohort', 'control');
    const minutesPerHour = 60;
    const hoursPerDay = 24;
    const defaultDelayInMinutes = minutesPerHour * hoursPerDay;
    const delayInMinutes = expConfig.get('delayInMinutes', defaultDelayInMinutes.toString());
    return {
        cohort: cohort,
        delayInMinutes: parseInt(delayInMinutes)
    };
};
const $0451aea256d3610a$var$isSiteOlderThanDelay = (delayInMinutes, siteActivationDateString)=>{
    if (!siteActivationDateString) return true; // If site has no activation date, assume it is old
    const siteActivationDateNumber = Number(siteActivationDateString);
    const siteActivationDate = new Date(siteActivationDateNumber ?? '');
    if (isNaN(siteActivationDate.getTime())) return true; // If site has no activation date, assume it is old
    const createdAtTimestamp = siteActivationDate.getTime();
    const millisecondsSinceCreation = Date.now() - createdAtTimestamp;
    const secondsPerMinute = 60;
    const millisecondsPerSecond = 1000;
    const millisecondsInDelayTime = delayInMinutes * secondsPerMinute * millisecondsPerSecond;
    return millisecondsSinceCreation > millisecondsInDelayTime;
};
module.exports["d1"] = $0451aea256d3610a$export$5ff0b879ab65d0b0;
module.exports["loading"] = $0451aea256d3610a$export$46c1c92549715335;
module.exports["d0"] = $0451aea256d3610a$export$61c0af74ec47d243;
module.exports["useCfind4473CreationFocusedNav"] = $0451aea256d3610a$export$a226a5c24cc00b77;

});

parcelRegister("7gpC4", function(module, exports) {
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $3654r = parcelRequire("3654r");


var $6MlG5 = parcelRequire("6MlG5");

var $9wgn8 = parcelRequire("9wgn8");

var $cVrnQ = parcelRequire("cVrnQ");

var $hcDON = parcelRequire("hcDON");

const $1f9fb6b4b3bc4020$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef78r4n _1h6r8r4n _smzgdfik _1dk7dfik _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $1f9fb6b4b3bc4020$var$Checkbox = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $42omo.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRefs = (0, $3654r.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $42omo.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $9wgn8.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $gMc0m.default)([
                    $1f9fb6b4b3bc4020$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6MlG5.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $l998X.jsxs)((0, $cVrnQ.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $l998X.jsx)((0, $hcDON.default), {})
                ]
            })
        ]
    });
}));
$1f9fb6b4b3bc4020$var$Checkbox.displayName = 'Checkbox';
var $1f9fb6b4b3bc4020$export$2e2bcd8739ae039 = $1f9fb6b4b3bc4020$var$Checkbox;
module.exports["default"] = $1f9fb6b4b3bc4020$export$2e2bcd8739ae039;

});

parcelRegister("6MlG5", function(module, exports) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $71feb0a29953fded$var$svgStyles = null;
function $71feb0a29953fded$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
     // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $71feb0a29953fded$var$CheckboxIcon = /*#__PURE__*/ (0, $42omo.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $42omo.useMemo)(()=>$71feb0a29953fded$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: 'var(--checkbox-background-color)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: 'var(--checkbox-tick-color)'
        },
        role: "presentation",
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }),
                icon
            ]
        })
    });
});
var $71feb0a29953fded$export$2e2bcd8739ae039 = $71feb0a29953fded$var$CheckboxIcon;
module.exports["default"] = $71feb0a29953fded$export$2e2bcd8739ae039;

});

parcelRegister("9wgn8", function(module, exports) {
$parcel$export(module.exports, "default", () => $edf27753e59bf881$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $edf27753e59bf881$var$baseStyles = null;
const $edf27753e59bf881$var$textLabelLayoutStyles = null;
const $edf27753e59bf881$var$disabledStyles = null;
const $edf27753e59bf881$var$labelStyles = null;
function $edf27753e59bf881$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("label", {
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _syazi7uo _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1gmx _80om13gf",
            "_h5e31j9a _1nzsr01l _1eszjmqp _yp0j1q28 _ay2wby5v _d51ul4ek _phftrsbi _1g1f1l7x _l6wkjmqp _1dik1q28 _1sfg1bqt _fpdjby5v _1yjc1v1w _oaj1rsbi _1j3h1bqt _eawb5w2r _1rda5w2r _18q02sac _13hr1j28",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("cVrnQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0c2060f65a94bd0$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $f0c2060f65a94bd0$var$labelTextStyles = null;
function $f0c2060f65a94bd0$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("hcDON", function(module, exports) {
$parcel$export(module.exports, "default", () => $a14852587cdb2524$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a14852587cdb2524$var$requiredIndicatorStyles = null;
function $a14852587cdb2524$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "aria-hidden": true,
        className: (0, $gMc0m.default)([
            "_syaz1tmw _bozgv77o"
        ]),
        children: "*"
    });
}

});


//# sourceMappingURL=SmartCreateFeedbackBanner.3cae7093.js.map
